import { hasElements, removeDuplicates } from "utils/arrays";

export const buildUserState = (user) => {
    const permissions = hasElements(user.groups)
        ? user.groups.reduce((arr, group) => {
              const groupPermissions = hasElements(group.permissions) && group.permissions.map((permission) => permission.id);
              return removeDuplicates([...arr, ...groupPermissions]);
          }, [])
        : [];

    const isAdmin = permissions.includes("general.admin");

    return {
        ...user,
        groups: user.groups.map((group) => ({ id: group.id, name: group.name })),
        permissions,
        isAdmin,
    };
};
